import { render, staticRenderFns } from "./expertRating.vue?vue&type=template&id=23877704&scoped=true&"
import script from "./expertRating.vue?vue&type=script&lang=js&"
export * from "./expertRating.vue?vue&type=script&lang=js&"
import style0 from "./expertRating.vue?vue&type=style&index=0&id=23877704&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23877704",
  null
  
)

export default component.exports